export default __webpack_public_path__ + "static/media/do.38bc7149.svg";